import PropTypes from 'prop-types';
import _ from 'lodash';

const MultiSelectCheckbox = ({
  value = [],
  onChange,
  options,
  label = undefined,
  error = undefined,
  style = undefined,
}) => {
  const handleCheckboxChange = (optionValue, checked) => {
    const newValue = [...value];
    if (checked) {
      if (!newValue.includes(optionValue)) newValue.push(optionValue);
    } else {
      const index = newValue.indexOf(optionValue);
      if (index !== -1) newValue.splice(index, 1);
    }
    onChange(newValue);
  };

  return (
    <div style={{ position: 'relative', ...style }}>
      {label && <p className="onboarding-label">{label}</p>}
      {_.map(options, (option, i) => (
        <div className="multi-select-checkbox" key={i}>
          <input
            type="checkbox"
            name={`checkbox-${i}`}
            value={option.value}
            checked={value.includes(option.value)}
            onChange={e => handleCheckboxChange(option.value, e.target.checked)}
          />
          <div className="box">
            <span>{option.label}</span>
          </div>
        </div>
      ))}
      {error && <p className="onboarding-error">{error}</p>}
    </div>
  );
};

MultiSelectCheckbox.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  style: PropTypes.object,
};

export default MultiSelectCheckbox;
